/**
 * @generated SignedSource<<c1ec16aa204efcd572c73fdf2f8ba563>>
 * @relayHash 4fe08de94bd106026bba6b3f2da24517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a02ad95b4567b460cfe19e5b6792c80290206e612fdd8a4c17d3a68fca03bca6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a02ad95b4567b460cfe19e5b6792c80290206e612fdd8a4c17d3a68fca03bca6",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
